























import {Component, Vue} from 'vue-property-decorator';
import {OrdersListSummary} from "@/model/OrdersListSummary";
import { EventBus } from '@/helpers/EventBus';
import { OrdersList } from '@/model/OrdersList';
import dayjs from 'dayjs';
import formatDate from '@/filters/DateFormatter';

@Component({
  filters: { formatDate }
})
export default class TotalOrderNumber extends Vue {

  private summary: OrdersListSummary = new OrdersListSummary();

  created() {
    EventBus.$on(EventBus.REFRESH_ORDERS_LIST, (ordersList: OrdersList) => this.summary = ordersList.summary);
  }

  get nextDayOrdersCount(): number {
    if (this.summary == null) {
      return 0;
    }

    if (this.summary.totalOrders == null) {
      return 0;
    }

    return this.summary.pendingReservationOrders;
  }

  get hasNextDayOrdersCount(): boolean {
    return this.nextDayOrdersCount > 0;
  }

  get nextDay(): Date {
    const nextDay = dayjs().add(1, 'day').startOf('day');

    return nextDay.toDate();
  }
}
